<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1"><a id="start">Prologue</a></h1><a id="start">
<p class="noind" style="margin-top:30px;"><i>A<span class="small">RMS ARE IMPORTANT. THEY</span> reach for things, they hug, they lift and carry, they perform tasks, they wave hello and good-bye.</i></p>
<p class="ind"><i>Legs are important. They move a body from place to place, they pedal, they drive a car, they dance, they jog, they kick a football, they jump.</i></p>
<p class="ind"><i>A mouth talks, eats, drinks, kisses, argues, smiles.</i></p>
<p class="ind"><i>A nose sneezes and smells roses and cabbage.</i></p>
<p class="ind"><i>Ears hear music and conversation and bells and train whistles and babies crying.</i></p>
<p class="ind"><i>Eyes see things, cry, wink. Eyes reflect the soul.</i></p>
<p class="ind"><i>But it is the mind that matters most. When the mind is lost,</i> all <i>is lost.</i></p>
<p class="ind"><i>A mind is a terrible thing to lose.</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4chap1.vue?77184e6b